/**
 * Created by Alex Bol on 2/19/2017.
 */
module.exports = {
    ILLEGAL_PARAMETERS: new ReferenceError('Illegal Parameters'),
    ZERO_DIVISION: new Error('Zero division')
};

